import React from "react";
import LinearProgress from "@material-ui/core/LinearProgress";
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  root: {
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
    paddingTop: '10px'
  },
  totalProgress: {
    width: '100%',
    height: '10px',
    borderRadius: '6px'
  },
  main: {
    height: '10px'
  },
  secondary: {
    height: '6px'
  }
}));

const ProgressBar = ({ percentComplete, main }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <LinearProgress
        variant="determinate"
        value={Math.min(percentComplete, 100)}
        classes={{ root: `${classes.totalProgress} ${main ? classes.main : classes.secondary}` }}
      />
    </div>
  );
}

export default ProgressBar;
